import React, { FC } from 'react';
import { Route, Switch, Redirect, useRouteMatch } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';
import { env } from 'Shared/constants/env';
import { Home } from '../../QuoteApp/components/Home/Home';

import { ErrorBoundaryPage } from 'QuoteApp/components';

type RouteParams = {
  appId: string;
};

export const AgentQuoteRouter: FC = () => {
  const match = useRouteMatch<RouteParams>();
  const path = match?.path;
  return (
    <ErrorBoundary FallbackComponent={ErrorBoundaryPage}>
      <Switch>
        {env.agentTestPagesEnabled && (
          <Route path={path} exact component={Home} />
        )}
        <Redirect path={path} to="/quotes" />
      </Switch>
    </ErrorBoundary>
  );
};
